import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import CheckboxControl from './checkbox';
import { IOtherFormulas, TConcatArraysReturnType } from '../types';

const items = [
  {
    name: 'preferred',
    key: 'Preferred',
    label: 'Preferred',
  },
  {
    name: 'custom',
    key: 'f(x)',
    label: 'f(x)',
  },
  {
    name: 'variableMfgCost',
    key: 'Variable Mfg Costs',
    label: 'Variable Mfg Costs',
  },
];

const CheckboxWrap = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
`;

export default ({
  allTypesMarkerList,
  updateMarkerList,
  otherFormulas,
}: {
  allTypesMarkerList: TConcatArraysReturnType[];
  updateMarkerList: Function;
  otherFormulas?: IOtherFormulas[];
}) => {
  const [checkedItems, setCheckedItems] = useState([] as string[]);
  let val;
  if (otherFormulas) {
    val = [...otherFormulas, ...allTypesMarkerList];
  } else {
    val = [...allTypesMarkerList];
  }
  const allMarkers = _.unionBy(val, 'name');

  useEffect(() => {
    let newArr;
    if (checkedItems.length === 0) {
      updateMarkerList(allMarkers);
    } else {
      newArr = allMarkers.filter(marker => marker.types && checkedItems.includes(marker.types));
      updateMarkerList(newArr);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allMarkers.length, checkedItems, updateMarkerList]);

  const onFilterChange = (filter: string) => {
    if (checkedItems.includes(filter)) {
      const filterIndex = checkedItems.indexOf(filter);
      const newFilter = [...checkedItems];
      newFilter.splice(filterIndex, 1);
      setCheckedItems(newFilter);
    } else {
      setCheckedItems([...checkedItems, filter]);
    }
  };

  return (
    <CheckboxWrap>
      {items.map(item => (
        <CheckboxControl
          key={item.key}
          name={item.name}
          label={item.label}
          isChecked={checkedItems[item.name]}
          onClick={() => onFilterChange(item.name)}
        />
      ))}
    </CheckboxWrap>
  );
};
